export const eventPathHelper={
    course:'courses',
    subscription:'subscription',
    default:'tickets'
};
